/** @format */

import React, { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import BillingResultList from './BillingComponents/BillingResultList';
import { BillingFilterContainer } from './BillingComponents/BillingFilterContainer';
import BillingItemList from './BillingComponents/BillingItemList';
import BillingSelectedSimCardList from './BillingComponents/BillingSelectedSimCardList';
import { DateHelperTs } from '../../helpers/DateHelperTs';
import moment from 'moment';
import BillingFilterOptionsInterface from './interfaces/BillingFilterOptionsInterface';
import Filter from '../../interfaces/forms/Filter';
import { configDefault } from '../../core/config';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { cdrConstants } from '../../modules/cdr/actions';
import BillingPlatformResellerList from './BillingComponents/BillingPlatformResellerList';
import BillingSelectedPlatformResellerList from './BillingComponents/BillingSelectedPlatformResellerList';
import Order from '../../interfaces/forms/Order';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';

const useStyle = makeStyles(adescomStyle);

const initialBillingFilterState: BillingFilterOptionsInterface = {
    incoming: true,
    outgoing: true,
    zeroDuration: false,
    dateStartAt: DateHelperTs.getMonthFirstDaySimple(moment()),
    dateEndAt: DateHelperTs.getMonthLastDaySimple(moment()),
    timeStartAt: '00:00',
    timeEndAt: '23:59',
    call: true,
    data: true,
    sms: true,
    mms: true,
    onlyNonTarrified: false,
    onlySubscribe: false,
    onlyService: false,
    selectedFraction: [],
    platformResellersIds: [],
};

export const BillingList = (props: any): React.ReactElement => {
    const CLIENT_BILLING_TYPE = 0;
    const RESELLER_BILLING_TYPE = 1;

    const [selectedNumbers, setSelectedNumbers] = useState<Array<string>>([]);
    const [selectedPlatformUsers, setSelectedPlatformUsers] = useState<Array<{ mainname: string; id: number; nip: string }>>([]);
    const [billingFilter, setBillingFilter] = useState<BillingFilterOptionsInterface>(initialBillingFilterState);
    const [preparedBillingFilter, setPreparedBillingFilter] = useState<Array<Filter>>([]);
    const [billingType, setBillingType] = useState<number>(CLIENT_BILLING_TYPE);
    const [billingOrder, setBillingOrder] = useState<Array<Order>>([{ name: 'calldate', value: 'desc' }]);
    const [selectedPlatformReseller, setSelectedPlatformReseller] = useState<number | null>(null);

    const changeBillingOrder = (orders: Array<Order>): void => {
        setBillingOrder(orders);
        searchBilling(orders);
    };

    const classes = useStyle();
    const dispatch = useDispatch();

    const changeBillingType = (event: any): void => {
        setBillingType(event.target.value);
        if (event.target.value === CLIENT_BILLING_TYPE) {
            setSelectedPlatformUsers([]);
            setSelectedPlatformReseller(null);
        }

        if (event.target.value === RESELLER_BILLING_TYPE) {
            setSelectedNumbers([]);
            setSelectedPlatformReseller(null);
        }
    };

    const searchBilling = (orders?: Array<Order>): void => {
        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/cdr_lists', configDefault.PLATFORM_API_PREFIX)),
            cdrConstants.LIST,
            [...preparedBillingFilter, { name: 'onlyLoggedReseller', value: true }],
            orders ?? billingOrder,
            (data: any) => {},
            {
                propagateDataToCallback: false,
                dispatchAfterCallback: true,
            }
        );
    };

    const paginationForSearchedBilling = (uri?: string): void => {
        if (!uri) {
            uri = FormGeneralHelper.getPath('/cdr_lists', configDefault.PLATFORM_API_PREFIX);
        }

        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(uri),
            cdrConstants.LIST,
            [...preparedBillingFilter, { name: 'onlyLoggedReseller', value: true }],
            billingOrder,
            (data: any) => {},
            {
                propagateDataToCallback: false,
                dispatchAfterCallback: true,
            }
        );
    };

    const selectNumber = (params: any): void => {
        if (!selectedNumbers.includes(params.number)) {
            setSelectedNumbers([...selectedNumbers, params.number]);
        }
    };
    const selectPlatformReseller = (params: { mainname: string; id: number; nip: string }): void => {
        let exists = false;
        selectedPlatformUsers.map((el: { mainname: string; id: number; nip: string }) => {
            if (params.id === el.id) {
                exists = true;
            }
        });

        if (!exists) {
            const newPlatformUsers = [...selectedPlatformUsers, params];
            setSelectedPlatformUsers(newPlatformUsers);
        }
    };
    const removeNumber = (params: any): void => {
        const newArr = selectedNumbers.filter((item: any) => {
            return item !== params.number;
        });

        setSelectedNumbers(newArr);
    };

    const removePlatformReseller = (params: { mainname: string; id: number; nip: string }): void => {
        let newSelected = [...selectedPlatformUsers];
        newSelected.map((el: { mainname: string; id: number; nip: string }, indx: number) => {
            if (params.id === el.id) {
                newSelected.splice(indx, 1);
            }
        });
        setSelectedPlatformUsers(newSelected);
    };

    const clearNumbers = (): void => {
        setSelectedNumbers([]);
        setSelectedPlatformReseller(null);
    };
    const clearPlatformResellers = (): void => {
        setSelectedPlatformUsers([]);
        setSelectedPlatformReseller(null);
    };

    const updateFilterState = (value: any, type: string): void => {
        if (typeof value === 'string' || typeof value === 'boolean') {
            setBillingFilter({
                ...billingFilter,
                [type]: value,
            });
        }
        if (typeof value === 'object') {
            if (type === 'dateStartAt' || type === 'dateEndAt') {
                setBillingFilter({
                    ...billingFilter,
                    [type]: moment(value).format('YYYY-MM-DD'),
                });
            }

            if (type === 'timeStartAt' || type === 'timeEndAt') {
                setBillingFilter({
                    ...billingFilter,
                    [type]: moment(value).format('HH:mm'),
                });
            }
        }
        if (Array.isArray(value) && type === 'selectedFraction') {
            setBillingFilter({
                ...billingFilter,
                [type]: value,
            });
        }
    };

    const prepareBillingFilters = useCallback((): Array<Filter> => {
        const filters = [];
        let isStartDatePrepared = false;
        let isEndDatePrepared = false;
        let startDatePrepared = '';
        let endDatePrepared = '';
        for (const [key, value] of Object.entries(billingFilter)) {
            if (key === 'dateStartAt' || key === 'timeStartAt') {
                if (!isStartDatePrepared) {
                    startDatePrepared = billingFilter.dateStartAt + ' ' + billingFilter.timeStartAt;
                    isStartDatePrepared = true;
                    filters.push({ name: 'startDate', value: startDatePrepared });
                }
            } else if (key === 'dateEndAt' || key === 'timeEndAt') {
                if (!isEndDatePrepared) {
                    endDatePrepared = billingFilter.dateEndAt + ' ' + billingFilter.timeEndAt;
                    isEndDatePrepared = true;
                    filters.push({ name: 'endDate', value: endDatePrepared });
                }
            } else if (key === 'notSelectedFraction') {
                filters.push({ name: 'notSelectedFraction', value: value.join(',') });
            } else {
                filters.push({ name: key, value: value });
            }
        }
        if (selectedNumbers.length > 0) {
            let numbers = selectedNumbers.join(',');
            filters.push({ name: 'msisdn', value: numbers });
        }

        if (selectedPlatformReseller) {
            filters.push({ name: 'selectedPlatformReseller', value: selectedPlatformReseller });
        }

        if (selectedPlatformUsers.length > 0) {
            const ids: Array<number> = [];

            selectedPlatformUsers.map((el: { mainname: string; nip: string; id: number }) => {
                ids.push(el.id);
            });

            const idsAsStr = ids.join(',');
            filters.push({ name: 'platformResellersIds', value: idsAsStr });
        }

        return filters;
    }, [billingFilter, selectedNumbers, selectedPlatformUsers, selectedPlatformReseller]);

    useEffect(() => {
        const prepared = prepareBillingFilters();
        setPreparedBillingFilter(prepared);
    }, [prepareBillingFilters, billingFilter]);

    return (
        <GridContainer>
            <GridItem xs={12} md={12} lg={12}>
                <GridContainer spacing={2}>
                    <GridItem xs={6} md={3} lg={12}>
                        <BillingFilterContainer
                            updateFilterState={updateFilterState}
                            billingFilter={billingFilter}
                            classes={classes}
                            changeBillingType={changeBillingType}
                            billingType={billingType}
                            selectedPlatformReseller={selectedPlatformReseller}
                            setSelectedPlatformReseller={setSelectedPlatformReseller}
                        />
                    </GridItem>
                    <GridItem xs={12} md={7} lg={7}>
                        {billingType === CLIENT_BILLING_TYPE && (
                            <BillingItemList selectNumberCallback={selectNumber} selectedPlatformReseller={selectedPlatformReseller} />
                        )}
                        {billingType === RESELLER_BILLING_TYPE && (
                            <BillingPlatformResellerList
                                selectedPlatformUsers={selectedPlatformUsers}
                                selectPlatformReseller={selectPlatformReseller}
                            />
                        )}
                    </GridItem>
                    <GridItem xs={12} md={5} lg={5}>
                        {billingType === CLIENT_BILLING_TYPE && (
                            <BillingSelectedSimCardList
                                selectedNumbers={selectedNumbers}
                                removeNumberCallback={removeNumber}
                                clearNumbersCallback={clearNumbers}
                                searchBillingCallback={searchBilling}
                            />
                        )}
                        {billingType === RESELLER_BILLING_TYPE && (
                            <BillingSelectedPlatformResellerList
                                selectedPlatformUsers={selectedPlatformUsers}
                                removePlatformResellerCallback={removePlatformReseller}
                                clearPlatformResellersCallback={clearPlatformResellers}
                                searchBillingCallback={searchBilling}
                            />
                        )}
                    </GridItem>
                    <GridItem xs={12} md={12} lg={12}>
                        <BillingResultList
                            showMainLoader={props.showMainLoader}
                            filters={preparedBillingFilter}
                            orders={billingOrder}
                            setOrders={changeBillingOrder}
                            paginationForSearchedBilling={paginationForSearchedBilling}
                        />
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};
